import { addToaster, getAllLayoutRecordsBasedOnService } from '@app-store'
import { entityRoute, tabRoute, viewRoute } from '../routes/route.constant'
import { DefaultLayout } from '../types/layoutRecordsBasedOnService.type'
import { LAYOUT_TYPE_NAMESPACE } from './constants'
import { store } from './agent.store'
import { v4 as uuid } from 'uuid'
import { DYNAMIC_QUEUE_MESSAGES } from '../constants/dynamicQueue'
import { getEntityDataByIdEntityNameEmbedded } from '../apis/entityData.api'
import {
  CHECK_ATTACH_IF_CASE,
  NavigationTypes,
} from '../constants/intakeQue.constants'
import { NavigateFunction } from 'react-router-dom'

const openWindow = (
  path: string,
  openInNewWindow: NavigationTypes,
  navigate?: NavigateFunction
) => {
  if (!path) return
  if (openInNewWindow === NavigationTypes.NEW_WINDOW)
    window.open(
      `${
        window.location.origin.endsWith('/')
          ? window.location.origin.slice(0, -1)
          : window.location.origin
      }${path}`,
      '_blank'
    )
  else {
    navigate && navigate(path)
  }
}

const getPathForOverviewUrl = (
  caseId: number,
  caseEntityId: number | undefined,
  layoutId: number,
  layoutType: string
) => {
  return layoutType === LAYOUT_TYPE_NAMESPACE.TABS_TYPE
    ? `/${entityRoute}/${caseEntityId}/${tabRoute}/${caseId}?layoutId=${layoutId}`
    : `/${entityRoute}/${caseEntityId}/${viewRoute}/${caseId}?layoutId=${layoutId}`
}
export const handleOpenLink = async (
  caseId: number,
  caseEntityId: number | undefined,
  service_id?: number,
  openInNewWindow = true,
  navigate?: NavigateFunction,
  returnLayoutId = false
) => {
  try {
    if (!caseEntityId || !caseId || !service_id) return
    const navigationType = openInNewWindow
      ? NavigationTypes.NEW_WINDOW
      : NavigationTypes.SAME_WINDOW
    const layoutResponse = await getAllLayoutRecordsBasedOnService(service_id)
    const layoutData = layoutResponse?.data ?? {}
    if (layoutData?.caseTypeLayoutsPage?.overview_layout_id?.id) {
      if (returnLayoutId)
        return layoutData?.caseTypeLayoutsPage?.overview_layout_id?.id
      const path = getPathForOverviewUrl(
        caseId,
        caseEntityId,
        layoutData?.caseTypeLayoutsPage?.overview_layout_id?.id,
        layoutData?.caseTypeLayoutsPage?.overview_layout_id?.type
      )
      openWindow(path, navigationType, navigate)
    } else {
      const overwiewLayout = layoutData?.defaultLayouts?.filter(
        (layout: DefaultLayout) =>
          layout?.type === LAYOUT_TYPE_NAMESPACE.OVERVIEW_TYPE ||
          layout?.type === LAYOUT_TYPE_NAMESPACE.TABS_TYPE
      )?.[0]
      if (overwiewLayout) {
        if (returnLayoutId) return overwiewLayout?.id
        const path = getPathForOverviewUrl(
          caseId,
          caseEntityId,
          overwiewLayout?.id,
          overwiewLayout?.type
        )
        openWindow(path, navigationType, navigate)
      } else {
        store.dispatch(
          addToaster({
            message: DYNAMIC_QUEUE_MESSAGES.NO_LAYOUT_MESSAGE,
            type: 'success',
            id: uuid(),
          })
        )
      }
    }
  } catch (e) {
    console.error(e)
  }
}
export const getLayoutBasedOnServiceType = async (
  id: number,
  isAttachCase: boolean
) => {
  const apiStatus = {
    apiCompleted: false,
    layoutData: null,
  }
  try {
    if (isAttachCase && id) {
      const servicesData = await getEntityDataByIdEntityNameEmbedded(
        'case',
        ['services'],
        id
      )
      if (servicesData?.data?.services?.id) {
        const layoutData = await getAllLayoutRecordsBasedOnService(
          servicesData?.data?.services?.id
        )
        apiStatus.apiCompleted = true
        if (layoutData?.data?.caseTypeLayoutsPage.edit_layout_id) {
          apiStatus.layoutData =
            layoutData?.data?.caseTypeLayoutsPage.edit_layout_id
        } else {
          apiStatus.apiCompleted = true
          apiStatus.layoutData = null
        }
      } else {
        apiStatus.apiCompleted = true
        apiStatus.layoutData = null
      }
    } else {
      apiStatus.apiCompleted = true
      apiStatus.layoutData = null
    }
  } catch (e) {
    console.error(e)
  }
  return apiStatus
}

export const handleDashBoardEyeIconClick = async (
  caseEntityId: string | number | undefined,
  caseId: number
) => {
  try {
    if (!caseEntityId || !caseId) return
    const servicesData = await getEntityDataByIdEntityNameEmbedded(
      'case',
      ['services'],
      caseId
    )
    const services = servicesData?.data?.services
    if (services?.id) {
      await handleOpenLink(caseId, caseEntityId as number, services?.id)
    }
  } catch (e) {
    console.error(e)
  }
}

export const checkIfFromAttachCase = (recordId: string | null) => {
  const val = JSON.parse(sessionStorage.getItem(CHECK_ATTACH_IF_CASE) ?? 'null')
  if (val && recordId && val?.id === recordId) {
    return val
  } else {
    return null
  }
}

export const removeCheckAttachKeyFromSession = () => {
  sessionStorage.removeItem(CHECK_ATTACH_IF_CASE)
}
